import React, { useState } from 'react';
import Box from '@mui/material/Box';
import BranchsDropdown from '@components/BranchsDropdown/BranchsDropdown';
import ModalityDropdown from '@components/ModalityDropdown/ModalityDropdown';
import GroupsAndReferrersAutocomplete from 'app/features/studies/components/RefererForm/GroupsAndReferrersAutocomplete';
import ReferrersAndGroupsAutocomplete from 'app/features/studies/components/RefererForm/ReferrersAndGroupsAutocomplete';
import useSx from './sx';

type FiltersProp = {
  selectedIdentityId?: string;
  selectedBranchId?: number;
  selectedModalityId?: number;
};

type Props = {
  onFiltersChange: (filters: FiltersProp) => void;
};

const Filters = ({ onFiltersChange }: Props) => {
  const sx = useSx();
  const [filters, setFilters] = useState<FiltersProp>({});

  const handleFiltersChange = (key: string, value: string | number | undefined) => {
    const newFilters = { ...filters, [key]: value };

    setFilters(newFilters);
    onFiltersChange(newFilters);
  };

  return (
    <Box sx={sx.root}>
      <Box className="userInput-Root">
        <ReferrersAndGroupsAutocomplete
          placeholder="Buscar al médico referente o al grupo"
          onReferrerOrGroupSelect={(user) => {
            handleFiltersChange('selectedIdentityId', user?.identityId);
          }}
        />
      </Box>
      <Box className="userInput-Root">
        <GroupsAndReferrersAutocomplete
          placeholder="Buscar grupo"
          onReferrerSelect={(group) => {
            handleFiltersChange('selectedIdentityId', group ? `group:${group.referrersGroupId}` : undefined);
          }}
        />
      </Box>
      <BranchsDropdown
        handleSelectedBranchChange={(branch) => {
          handleFiltersChange('selectedBranchId', branch?.id);
        }}
      />
      <ModalityDropdown
        handleSelectedModality={(modality) => {
          handleFiltersChange('selectedModalityId', modality?.modalityId);
        }}
      />
    </Box>
  );
};

export default Filters;
